import type * as Types from 'app/types/graphql';

import { VariantTemplateSelectFragmentDoc } from '../fragments/variantTemplate.generated';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type VariantTemplateCreateMutationVariables = Types.Exact<{
  input: Types.CreateVariantTemplateInput;
}>;

export type VariantTemplateCreateMutationResponse = {
  variantTemplateCreate?: Types.Maybe<
    Pick<
      Types.VariantTemplate,
      | 'createdAt'
      | 'deletedAt'
      | 'id'
      | 'redirectURL'
      | 'themeID'
      | 'updatedAt'
      | 'thumbnailURL'
      | 'title'
    >
  >;
};

export const VariantTemplateCreateDocument = `
    mutation VariantTemplateCreate($input: CreateVariantTemplateInput!) {
  variantTemplateCreate(input: $input) {
    ...VariantTemplateSelect
  }
}
    ${VariantTemplateSelectFragmentDoc}`;

export const useVariantTemplateCreateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    VariantTemplateCreateMutationResponse,
    TError,
    VariantTemplateCreateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    VariantTemplateCreateMutationResponse,
    TError,
    VariantTemplateCreateMutationVariables,
    TContext
  >(
    ['VariantTemplateCreate'],
    (variables?: VariantTemplateCreateMutationVariables) =>
      appFetcher<VariantTemplateCreateMutationResponse, VariantTemplateCreateMutationVariables>(
        VariantTemplateCreateDocument,
        variables,
      )(),
    options,
  );
};

useVariantTemplateCreateMutation.getKey = () => ['VariantTemplateCreate'];
